import React from "react";

const UpdateDialogBox = ({
  open,
  onClose,
  onSubmit,
  headerTitle,
  title,
  isLoader,
}) => {
  if (!open) return null;

  return (
    <div
      id="confirmationmodal"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
      aria-modal="true"
      className="modal"
      style={{
        display: "block",
        position: "fixed",
        inset: "0",
        width: "100%",
        height: "100% ",
        zIndex: "80",
        marginLeft:"0",
        background: "linear-gradient(45deg,rgba(0,0,0,.3),rgba(0,0,0,.3))",
      }}
    >
      <div className="modal-md modal-dialog-scrollable pop_box1 ">
        <span tabIndex={0} />
        <div id="modal_content_" tabIndex={-1} className="modal-content">
          <header
            style={{
              background: "#dff0d8",
              padding: "9px 15px",
              borderBottom: "1px solid #e5e5e5",
            }}
            id="modal_header_"
            className="modal-header"
          >
            <h4
              id="popup_title"
              className="modal-title text-uppercase"
              style={{
                fontWeight: "bold",
                fontFamily: "Tahoma, Helvetica, sans-serif",
                fontSize: "12px",
                color: "black",
              }}
            >
              {headerTitle}
            </h4>
          </header>

          <div id="modal_body_" className="modal-body">
            <div
              className="form-group"
              style={{ display: "table", width: "100%", margin: "5px 0px" }}
            >
              <div
                role="alert"
                aria-live="polite"
                aria-atomic="true"
                style={{ margin: "0" }}
              >
                <div direction="right">
                  <span id="popup_msg" style={{ fontSize: "15px" }}>
                    {title}
                  </span>
                </div>
              </div>
            </div>

            <div
              className="col-lg-12 col-12 text-right"
              style={{
                display: "flex",
                placeContent: "center",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                id="popup_confirm"
                className="btn-send close_modal"
                style={{ width: "100px", marginRight: "12px" }}
                disabled={isLoader}
                onClick={() => onSubmit()}
              >
                <i className="fa fa-check-circle" />{" "}
                {isLoader ? "...Loading" : "Confirm"}
              </button>

              <button
                type="button"
                className="btn-send close_modal"
                style={{ width: "100px" }}
                onClick={onClose}
              >
                <i className="fa fa-times-circle" /> Cancel
              </button>
            </div>
          </div>
        </div>
        <span tabIndex={0} />
      </div>
    </div>
  );
};

export default UpdateDialogBox;
